var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    fillRule: "evenodd",
    d: "M3.82353 1.6C3.82353 0.716344 4.47715 0 5.28342 0C5.79121 0 6.23845 0.284136 6.5 0.715255C6.76155 0.284136 7.20879 0 7.71658 0C8.52285 0 9.17647 0.716344 9.17647 1.6C9.17647 1.73812 9.1605 1.87215 9.13048 2H12.2C12.6418 2 13 2.35817 13 2.8V4.4H0V2.8C0 2.35817 0.358172 2 0.8 2H3.86952C3.8395 1.87215 3.82353 1.73812 3.82353 1.6ZM6.25668 2H4.38091C4.34392 1.89986 4.32041 1.79216 4.31283 1.67961L4.31016 1.6C4.31016 1.0109 4.7459 0.533333 5.28342 0.533333C5.79651 0.533333 6.21686 0.968468 6.25401 1.52039L6.25668 1.6V2ZM8.61909 2H6.74332V1.6L6.74599 1.52039C6.78314 0.968468 7.20349 0.533333 7.71658 0.533333C8.2541 0.533333 8.68984 1.0109 8.68984 1.6L8.68717 1.67961C8.67959 1.79216 8.65608 1.89986 8.61909 2ZM5.73529 5.2H0.764706V10.4C0.764706 11.2837 1.48105 12 2.36471 12H5.73529V5.2ZM7.26471 12H10.6353C11.5189 12 12.2353 11.2837 12.2353 10.4V5.2H7.26471V12Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.934939d90526e096dbfc05b1a3b2aa7a.svg";
export { ForwardRef as ReactComponent };